export default __webpack_public_path__ + "static/media/immeasureableempowerment.f41e39bd.png";